// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bJn_","left":"styles_left__ngiua"};